// User roles enum
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  CHEF: 'chef',
  CLIENT: 'client'
};

// User status enum
export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
  PENDING: 'pending'
};

// User preferences structure
export const defaultUserPreferences = {
  language: 'es',
  theme: 'light',
  notifications: {
    email: true,
    push: false,
    mealPlanReminders: true,
    recipeUpdates: false
  },
  dietary: {
    restrictions: [],
    allergies: [],
    preferences: []
  },
  display: {
    recipesPerPage: 20,
    defaultView: 'grid',
    showNutritionalInfo: true
  }
};

// User model structure
export const userModel = {
  id: '',
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  role: USER_ROLES.USER,
  status: USER_STATUS.ACTIVE,
  avatar: '',
  phone: '',
  address: {
    street: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
  },
  preferences: defaultUserPreferences,
  metadata: {
    createdAt: null,
    updatedAt: null,
    lastLogin: null,
    loginCount: 0
  },
  permissions: {
    canCreateRecipes: true,
    canEditRecipes: true,
    canDeleteRecipes: false,
    canManageUsers: false,
    canManagePlans: true,
    canViewReports: false
  }
};

// Permission presets by role
export const rolePermissions = {
  [USER_ROLES.ADMIN]: {
    canCreateRecipes: true,
    canEditRecipes: true,
    canDeleteRecipes: true,
    canManageUsers: true,
    canManagePlans: true,
    canViewReports: true
  },
  [USER_ROLES.CHEF]: {
    canCreateRecipes: true,
    canEditRecipes: true,
    canDeleteRecipes: true,
    canManageUsers: false,
    canManagePlans: true,
    canViewReports: true
  },
  [USER_ROLES.USER]: {
    canCreateRecipes: true,
    canEditRecipes: true,
    canDeleteRecipes: false,
    canManageUsers: false,
    canManagePlans: true,
    canViewReports: false
  },
  [USER_ROLES.CLIENT]: {
    canCreateRecipes: false,
    canEditRecipes: false,
    canDeleteRecipes: false,
    canManageUsers: false,
    canManagePlans: false,
    canViewReports: false
  }
};